import Bus from "@/lib/Bus"
import { ITaskSearcher } from "server/src/task/ITaskSearcher";
const bus: Bus = new Bus().getBus();
import { ITask } from "../../server/src/task/ITask";
import { ITaskServer, task_api } from "../../server/src/task/ITaskServer";


export class TaskSvc implements ITaskServer {

    async fill_parent(task:ITask|undefined):Promise<ITask|undefined> {
        if (!task) return undefined;
        return await bus.api(task_api.fill_parent,{ task: task});
    }

    async save(task:ITask|undefined):Promise<ITask|undefined> {
        if (!task) return undefined;
        return await bus.api(task_api.save,{ task: task});
    }

    async find(searcher: ITaskSearcher):Promise<ITask[]> {
        return await bus.api(task_api.find,{ searcher: searcher});
    }
    
}

